/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sovereign_EscrowInputs */

const en_sovereign_escrow = /** @type {(inputs: Sovereign_EscrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign Escrow`)
};

const es_sovereign_escrow = /** @type {(inputs: Sovereign_EscrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custodia Sovereign`)
};

const fr_sovereign_escrow = /** @type {(inputs: Sovereign_EscrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entiercement Sovereign`)
};

const de_sovereign_escrow = /** @type {(inputs: Sovereign_EscrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign-Treuhand`)
};

const ja_sovereign_escrow = /** @type {(inputs: Sovereign_EscrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereignエスクロー`)
};

const zh_sovereign_escrow = /** @type {(inputs: Sovereign_EscrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign 托管平台`)
};

const ar_sovereign_escrow = /** @type {(inputs: Sovereign_EscrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نظام الضمان (Escrow) Sovereign`)
};

const id_sovereign_escrow = /** @type {(inputs: Sovereign_EscrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escrow Sovereign`)
};

const it_sovereign_escrow = /** @type {(inputs: Sovereign_EscrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escrow Sovereign`)
};

const ru_sovereign_escrow = /** @type {(inputs: Sovereign_EscrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign Эскроу`)
};

const pt_sovereign_escrow = /** @type {(inputs: Sovereign_EscrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escrow Sovereign`)
};

const ko_sovereign_escrow = /** @type {(inputs: Sovereign_EscrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign 에스크로`)
};

/**
* | output |
* | --- |
* | "Sovereign Escrow" |
*
* @param {Sovereign_EscrowInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const sovereign_escrow = /** @type {((inputs?: Sovereign_EscrowInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sovereign_EscrowInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sovereign_escrow(inputs)
	if (locale === "es") return es_sovereign_escrow(inputs)
	if (locale === "fr") return fr_sovereign_escrow(inputs)
	if (locale === "de") return de_sovereign_escrow(inputs)
	if (locale === "ja") return ja_sovereign_escrow(inputs)
	if (locale === "zh") return zh_sovereign_escrow(inputs)
	if (locale === "ar") return ar_sovereign_escrow(inputs)
	if (locale === "id") return id_sovereign_escrow(inputs)
	if (locale === "it") return it_sovereign_escrow(inputs)
	if (locale === "ru") return ru_sovereign_escrow(inputs)
	if (locale === "pt") return pt_sovereign_escrow(inputs)
	return ko_sovereign_escrow(inputs)
});